export const testInfo = {
    "question_number": "Number of questions",
    "question_number_learning": "Number of content need to be done",
    "number_of": "Attempt",
    "welcome_final_test": "Welcome to the final test",
    "max_try_time": "Maximum attempt",
    "number_try_time": "Number of attempts",
    "unlimited": "Unlimited attempts",
    "SUBMITTING": "Submitting",
};
